import { render, staticRenderFns } from "./step3Base.vue?vue&type=template&id=bb233366&scoped=true"
import script from "./step3Base.vue?vue&type=script&lang=js"
export * from "./step3Base.vue?vue&type=script&lang=js"
import style0 from "./step3Base.vue?vue&type=style&index=0&id=bb233366&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb233366",
  null
  
)

export default component.exports